import React, { useState } from "react";

import { useGetAlertRules } from "api/api-hooks/alert-rules-hooks";
import { AlertRuleDTO } from "api/model/alerts/alert-types";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { T } from "services/lang/LanguageService";
import AlertHistoryTable from "./alerts-management/AlertHistoryTable";
import AlertRuleForm from "./alerts-management/AlertRuleForm";
import AlertRulesTable from "./alerts-management/AlertRulesTable";

const AlertsManagement: React.FC = () => {
  const { data: rules, isLoading } = useGetAlertRules();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [editRule, setEditRule] = useState<AlertRuleDTO | null>(null);

  return (
    <div className="alerts-management">
      <TabView>
        <TabPanel header={T("label.alert-rules")}>
          <AlertRulesTable
            rules={rules}
            isLoading={isLoading}
            onEdit={setEditRule}
            onCreateClick={() => setCreateDialogOpen(true)}
          />
        </TabPanel>

        <TabPanel header={T("word.history")}>
          <AlertHistoryTable />
        </TabPanel>
      </TabView>

      <Dialog
        header={T("action.create-rule")}
        visible={createDialogOpen}
        onHide={() => setCreateDialogOpen(false)}
        style={{ width: "50rem" }}
      >
        <AlertRuleForm onClose={() => setCreateDialogOpen(false)} />
      </Dialog>

      <Dialog
        header={T("action.edit-rule")}
        visible={!!editRule}
        onHide={() => setEditRule(null)}
        style={{ width: "50rem" }}
      >
        {editRule && <AlertRuleForm rule={editRule} onClose={() => setEditRule(null)} />}
      </Dialog>
    </div>
  );
};

export default AlertsManagement;
